export const frontmatter = {
    "draft": false,
    "title": "Workflows",
    "sidebar_group": "reference",
    "sidebar_label": "Workflows",
    "sidebar_order": 1
}

export const toc = []